import axios, { type AxiosRequestConfig } from 'axios'
import { get } from './request'
import buildHost from './request/buildHost'

export enum CDNFileType {
	PIC = 'PIC',
	CLIENT_LOG = 'CLIENT_LOG',
	CUSTOM = 'CUSTOM',
	VIDEO = 'VIDEO',
	LIVE_PHOTO_PIC = 'LIVE_PHOTO_PIC',
	LIVE_PHOTO_VIDEO = 'LIVE_PHOTO_VIDEO',
}

interface GetProvisionConfig {
	uploadType?: CDNFileType
	bucket?: 'jike' | 'videos'
}

export interface CDNFile {
	fileUrl: string
	id: string
	key: string
}

const baseURL = buildHost('https://upload.ruguoapp.com')

const getProvision = (config?: GetProvisionConfig) => {
	return get<{ uptoken: string }>(`${baseURL}/token`, {
		params: {
			bucket: 'jike',
			...config,
		},
	})
}

export default async function uploadFile(
	file: Blob,
	config: AxiosRequestConfig & { provisionConfig?: GetProvisionConfig } = {}
): Promise<CDNFile> {
	return getProvision(config.provisionConfig).then(async ({ data: { uptoken } }) => {
		const formData = new FormData()

		formData.append('token', uptoken)
		formData.append('file', file)

		return axios
			.post<CDNFile>('https://upload.qiniup.com', formData, config)
			.then(({ data }) => data)
	})
}
